//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class MotorcycleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://az-api-dev.ractest.com.au/insurance/motorcycle/api/v2";
    }

    /**
     * GetAddresses
     * @param q The search term to apply onto the address to filter on.
     * @return The addresses matching the filter.
     */
    getaddresses(q: string): Promise<ApiResponse<AddressSummary[]>> {
        let url_ = this.baseUrl + "/addresses?";
        if (q === undefined || q === null)
            throw new globalThis.Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetaddresses(_response);
        });
    }

    protected processGetaddresses(response: Response): Promise<ApiResponse<AddressSummary[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressSummary[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<AddressSummary[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetManufacturers
     * @param q (optional) The search term to apply onto the manufacturer name to filter on.
     * @return The makers matching the filter (if applicable).
     */
    getmanufacturers(q?: string | null | undefined): Promise<ApiResponse<Manufacturer[]>> {
        let url_ = this.baseUrl + "/motorcycles/manufacturers?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmanufacturers(_response);
        });
    }

    protected processGetmanufacturers(response: Response): Promise<ApiResponse<Manufacturer[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Manufacturer[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Manufacturer[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetHealthStatus
     * @return No content
     */
    gethealthstatus(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/health/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGethealthstatus(_response);
        });
    }

    protected processGethealthstatus(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreditCardPayment
     * @param creditCardPaymentRequest (optional) Issue the policy in Shield using credit card for payment
     * @return Issue policy using credit card was successful
     */
    creditcardpayment(creditCardPaymentRequest?: CreditCardPaymentRequest | null | undefined): Promise<ApiResponse<PaymentResponse>> {
        let url_ = this.baseUrl + "/payments/credit-card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(creditCardPaymentRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreditcardpayment(_response);
        });
    }

    protected processCreditcardpayment(response: Response): Promise<ApiResponse<PaymentResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return new ApiResponse(status, _headers, result201);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return new ApiResponse(status, _headers, result204);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return throwException("Service is/was unavailable during payment. Requests may be retried again (with presence of Retry-After header).", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return throwException("Service unavailable.", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * ContactMatchAttemptsExhausted
     * @return The device still allowed to try again a contact match.
     */
    contactmatchattemptsexhausted(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/areyouamember/contact-match/attempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactmatchattemptsexhausted(_response);
        });
    }

    protected processContactmatchattemptsexhausted(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too many requests.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdatePolicyDetails
     * @param letsClarifyMoreDetailsRequest (optional) The policy details to update.
     * @return No Content.
     */
    updatepolicydetails(letsClarifyMoreDetailsRequest?: LetsClarifyMoreDetailsRequest | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/letsclarifymoredetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(letsClarifyMoreDetailsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatepolicydetails(_response);
        });
    }

    protected processUpdatepolicydetails(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetManufacturerYears
     * @param manufacturerExternalCode The manufacturer external code.
     * @return The list of years matching the manufacturer external code.
     */
    getmanufactureryears(manufacturerExternalCode: string): Promise<ApiResponse<number[]>> {
        let url_ = this.baseUrl + "/motorcycles/manufacturer-years/{manufacturerExternalCode}";
        if (manufacturerExternalCode === undefined || manufacturerExternalCode === null)
            throw new globalThis.Error("The parameter 'manufacturerExternalCode' must be defined.");
        url_ = url_.replace("{manufacturerExternalCode}", encodeURIComponent("" + manufacturerExternalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmanufactureryears(_response);
        });
    }

    protected processGetmanufactureryears(response: Response): Promise<ApiResponse<number[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("When manufacturer does not exist for the provided manufacturer external code.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<number[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetModels
     * @param manufacturerExternalCode The manufacturer external code.
     * @param year The vehicle model year for the manufacturer.
     * @return The models matching the manufacturer.
     */
    getmodels(manufacturerExternalCode: string, year: number): Promise<ApiResponse<Model[]>> {
        let url_ = this.baseUrl + "/motorcycles/manufacturers/{manufacturerExternalCode}/years/{year}/models";
        if (manufacturerExternalCode === undefined || manufacturerExternalCode === null)
            throw new globalThis.Error("The parameter 'manufacturerExternalCode' must be defined.");
        url_ = url_.replace("{manufacturerExternalCode}", encodeURIComponent("" + manufacturerExternalCode));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmodels(_response);
        });
    }

    protected processGetmodels(response: Response): Promise<ApiResponse<Model[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Model[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("When manufacturer does not exist.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Model[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * DeleteMatchedContactFromSession
     * @return Matched contact details successfully deleted from session
     */
    deletematchedcontactfromsession(): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/contacts/match";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletematchedcontactfromsession(_response);
        });
    }

    protected processDeletematchedcontactfromsession(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * MatchContact
     * @param matchContact (optional) The details used to match against a contact.
     * @return Match was successful
     */
    matchcontact(matchContact?: MatchContact | null | undefined): Promise<ApiResponse<MatchedContactDetails>> {
        let url_ = this.baseUrl + "/contacts/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchContact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchcontact(_response);
        });
    }

    protected processMatchcontact(response: Response): Promise<ApiResponse<MatchedContactDetails>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchedContactDetails;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Match not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Ambiguous matches.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<MatchedContactDetails>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetModel
     * @param vehicleId The motorcycle's vehicle identifier.
     * @return The motorcycle matching the vehicle identifier.
     */
    getmodel(vehicleId: number): Promise<ApiResponse<Model>> {
        let url_ = this.baseUrl + "/motorcycles/{vehicleId}";
        if (vehicleId === undefined || vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmodel(_response);
        });
    }

    protected processGetmodel(response: Response): Promise<ApiResponse<Model>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Model;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("When motorcycle model does not exist for the provided vehicle identifier.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Model>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreateQuote
     * @param quoteRequest (optional) The details of the quote to be created.
     * @return The created quote details.
     */
    createquote(quoteRequest?: QuoteRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatequote(_response);
        });
    }

    protected processCreatequote(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetTellMoreAboutYouReferenceData
     * @return The Tell Us More About You Reference Data that includes titles.
     */
    gettellmoreaboutyoureferencedata(): Promise<ApiResponse<TellUsMoreAboutYouReferenceData>> {
        let url_ = this.baseUrl + "/tellusmoreaboutyou/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGettellmoreaboutyoureferencedata(_response);
        });
    }

    protected processGettellmoreaboutyoureferencedata(response: Response): Promise<ApiResponse<TellUsMoreAboutYouReferenceData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TellUsMoreAboutYouReferenceData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<TellUsMoreAboutYouReferenceData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetPaymentReferenceData
     * @return The Payment Reference Data.
     */
    getpaymentreferencedata(): Promise<ApiResponse<PaymentReferenceData>> {
        let url_ = this.baseUrl + "/payments/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpaymentreferencedata(_response);
        });
    }

    protected processGetpaymentreferencedata(response: Response): Promise<ApiResponse<PaymentReferenceData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReferenceData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentReferenceData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateQuoteCover
     * @param coverRequest (optional) The details of the quote cover to be updated.
     * @return The updated quote details.
     */
    updatequotecover(coverRequest?: CoverRequest | null | undefined): Promise<ApiResponse<Cover>> {
        let url_ = this.baseUrl + "/quote/cover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coverRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatequotecover(_response);
        });
    }

    protected processUpdatequotecover(response: Response): Promise<ApiResponse<Cover>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Cover;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Cover>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetSessionExpiry
     * @return Session expiry in seconds retrieved successfully
     */
    getsessionexpiry(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session/expiry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetsessionexpiry(_response);
        });
    }

    protected processGetsessionexpiry(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 408) {
            return response.text().then((_responseText) => {
            let result408: any = null;
            result408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Session expired", status, _responseText, _headers, result408);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetSuburbs
     * @return The WA Suburbs.
     */
    getsuburbs(): Promise<ApiResponse<Suburb[]>> {
        let url_ = this.baseUrl + "/tellusmoreaboutyourbike/suburbs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetsuburbs(_response);
        });
    }

    protected processGetsuburbs(response: Response): Promise<ApiResponse<Suburb[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Suburb[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Suburb[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreateSession
     * @return Session creation was successful
     */
    createsession(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatesession(_response);
        });
    }

    protected processCreatesession(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetTellMoreAboutYourBikeRefData
     * @return The Tell Us More About Your Bike Reference Data based on a specific bike.
     */
    gettellmoreaboutyourbikerefdata(): Promise<ApiResponse<TellUsMoreAboutYourBikeRefData>> {
        let url_ = this.baseUrl + "/tellusmoreaboutyourbike/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGettellmoreaboutyourbikerefdata(_response);
        });
    }

    protected processGettellmoreaboutyourbikerefdata(response: Response): Promise<ApiResponse<TellUsMoreAboutYourBikeRefData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TellUsMoreAboutYourBikeRefData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<TellUsMoreAboutYourBikeRefData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetTellMoreAboutYouQuestions
     * @return The Tell Us More About You question information.
     */
    gettellmoreaboutyouquestions(): Promise<ApiResponse<TellUsMoreAboutYouQuestionsResponse>> {
        let url_ = this.baseUrl + "/tellusmoreaboutyou/questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGettellmoreaboutyouquestions(_response);
        });
    }

    protected processGettellmoreaboutyouquestions(response: Response): Promise<ApiResponse<TellUsMoreAboutYouQuestionsResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TellUsMoreAboutYouQuestionsResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Forbidden.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<TellUsMoreAboutYouQuestionsResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * BankAccountPayment
     * @param bankAccountPaymentRequest (optional) Issue the policy in Shield using bank account for payment
     * @return Issue policy using bank account was successful
     */
    bankaccountpayment(bankAccountPaymentRequest?: BankAccountPaymentRequest | null | undefined): Promise<ApiResponse<PaymentResponse>> {
        let url_ = this.baseUrl + "/payments/bank-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bankAccountPaymentRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankaccountpayment(_response);
        });
    }

    protected processBankaccountpayment(response: Response): Promise<ApiResponse<PaymentResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponse;
            return new ApiResponse(status, _headers, result201);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetRiderDetailsReferenceData
     * @return The Rider Details reference data.
     */
    getriderdetailsreferencedata(): Promise<ApiResponse<RiderDetailsReferenceData>> {
        let url_ = this.baseUrl + "/riderdetails/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetriderdetailsreferencedata(_response);
        });
    }

    protected processGetriderdetailsreferencedata(response: Response): Promise<ApiResponse<RiderDetailsReferenceData>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiderDetailsReferenceData;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<RiderDetailsReferenceData>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetFormotivModelScore
     * @param token The multi page token provided by formotiv that is associated with the members current session.
     * @return The formotiv model score.
     */
    getformotivmodelscore(token: string): Promise<ApiResponse<FormotivModelScoreResponse>> {
        let url_ = this.baseUrl + "/formotiv/model-score?";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetformotivmodelscore(_response);
        });
    }

    protected processGetformotivmodelscore(response: Response): Promise<ApiResponse<FormotivModelScoreResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormotivModelScoreResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<FormotivModelScoreResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateContactDetails
     * @param updateContactDetailsRequest (optional) The contact details.
     * @return The cover details of the updated quote.
     */
    updatecontactdetails(updateContactDetailsRequest?: UpdateContactDetailsRequest | null | undefined): Promise<ApiResponse<Cover>> {
        let url_ = this.baseUrl + "/tellusmoreaboutyou";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateContactDetailsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatecontactdetails(_response);
        });
    }

    protected processUpdatecontactdetails(response: Response): Promise<ApiResponse<Cover>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Cover;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict, ambiguous matches.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Cover>>(new ApiResponse(status, _headers, null as any));
    }
}

/** Contains the details regarding the error. */
export interface ErrorDto {
    /** The error message. */
    message: string;
}

/** Contains the details regarding the Manufacturer. */
export interface Manufacturer {
    /** The external code representing the Manufacturer. */
    externalCode: string;
    /** The name of the Manufacturer. */
    name: string;
    /** Whether the manufacturer is a popular. */
    isPopular?: boolean | undefined;
}

/** Contains the details regarding the Model. */
export interface Model {
    /** The vehicle id of the motorcycle model. */
    id: number | undefined;
    /** The external code of the motorcycle manufacturer. */
    manufacturer: string;
    /** The name of the motorcycle model. */
    name: string;
    /** The model year of the motorcycle model. */
    year: number;
    /** The engine capacity of the motorcycle model. */
    engineCapacity: string;
}

/** The generic reference data structure. */
export interface ReferenceDataItem {
    /** Reference data item external code. */
    externalCode: string;
    /** Reference data item description. */
    description: string;
}

/** The title reference data structure. */
export interface TitleReferenceDataItem {
    /** Reference data item external code. */
    externalCode: string;
    /** Reference data item description. */
    description: string;
    /** The gender correspondence to the title. */
    gender?: ReferenceDataItem | undefined;
}

/** A suburb in WA with postcode from Shield. */
export interface Suburb {
    /** The display name (Name - Postcode). */
    cityName: string;
    /** The suburb name. */
    name: string;
    /** The suburb postcode */
    postcode: string;
}

/** Contains the reference data that is required to populate the Tell Us More About You form. */
export interface TellUsMoreAboutYouReferenceData {
    /** The list of titles. */
    titles: TitleReferenceDataItem[];
    /** Whether a single contact match has happened. */
    hasContactMatched: boolean;
    /** Postal address from the contact matched. */
    postalAddress?: AddressSummary | undefined;
}

/** Contains the reference data that is required to populate the Rider Details page. */
export interface RiderDetailsReferenceData {
    /** The list of bike usage options. */
    bikeUsageOptions?: ReferenceDataItem[] | undefined;
}

/** Contains the address summary. */
export interface AddressSummary {
    /** The moniker representing the address. */
    moniker: string;
    /** The display text of the address. */
    displayAddress: string;
}

/** The query parameters for matching a contact. */
export interface MatchContact {
    /** The first name of the contact. */
    firstName: string;
    /** The date of birth of the contact. */
    dateOfBirth: Date;
    /** The mobile number of the contact. */
    mobileNumber: string;
    /** The email address of the contact. */
    email: string;
}

/** The details of the matched contact. */
export interface MatchedContactDetails {
    /** The matched contacts membership tier. */
    membershipTier: string;
    /** The matched contact response status. */
    status: number;
}

/** Contains the reference data that is required to populate the Tell Us More About Your bike form. */
export interface TellUsMoreAboutYourBikeRefData {
    /** The list of security options applied to a motorcycle. */
    bikeSecurityOptions: ReferenceDataItem[];
    /** List of options for the number of kilometers travelled in a year for a motorcycle. */
    annualKmsOptions: ReferenceDataItem[];
    /** The list of financiers. */
    financiers: Financier[];
}

/** Financial Institution contact. */
export interface Financier {
    /** The external contact number identifying the financial institution. */
    externalFinancierNumber: string;
    /** The name of the financial institution. */
    financierName: string;
}

/** Object to create and update a quote. */
export interface QuoteRequest {
    /** The object that contains the information of the motorcycle asset. */
    asset: Asset;
    /** The details of the rider(s). */
    riders: Rider[];
}

/** The motorcycle asset details. */
export interface Asset {
    /** The vehicle id. */
    vehicleId: number;
    /** The external code of the annual kilometers per year. */
    annualKilometreage: string;
    /** The collection of security fittings. */
    securityFittings?: string[] | undefined;
    /** Whether the bike uses dashcam or not. */
    usesDashcam?: boolean | undefined;
    /** Whether the bike is kept in the garage overnight. */
    isKeptInGarageOvernight?: boolean | undefined;
    /** The suburb where the bike is kept. */
    suburb: string;
    /** The postcode of the suburb where the bike is kept. */
    postcode: string;
    /** The external code of the bike usage. */
    usage?: string | undefined;
    /** The external code of financier. */
    financier?: string | undefined;
}

/** The rider details. */
export interface Rider {
    /** The date of birth of the rider. */
    dateOfBirth?: Date | undefined;
    /** The rider's experience. */
    experience: RiderExperience;
}

/** Object the details of the quote created or updated. */
export interface QuoteResponse {
    /** The quote number. */
    quoteNumber: string;
    /** The start date. */
    startDate: Date;
    /** The max start date. */
    maxStartDate: Date;
    /** The list of covers available for the quote. */
    covers: Cover[];
}

export interface NumberRange {
    /** The current value. */
    value: number;
    /** The minimum allowed value. */
    min: number;
    /** The maximum allowed value. */
    max: number;
}

/** The cover details. */
export interface Cover {
    /** The cover type. */
    coverType: string;
    /** The title of the cover. */
    title: string;
    /** The sum insured details. */
    sumInsured?: NumberRange | undefined;
    /** The selected excess amount for the cover. */
    selectedExcess: number;
    /** The list of excesses available for the quote. */
    availableExcesses: number[];
    /** The premium details. */
    premiumDetails: PremiumDetails;
    /** The list of discounts for the quote. */
    discounts?: Discount[] | undefined;
}

/** The discount details. */
export interface Discount {
    /** Membership tier. */
    membershipTier: string;
    /** Discount Type. */
    discountType: string;
    /** Discount Value. */
    value?: number | undefined;
    /** Discount Percentage. */
    percent?: number | undefined;
    /** Discount Description. */
    description: string;
    /** Discount validation flag. */
    isValidDiscount: boolean;
}

/** The premium details. */
export interface PremiumDetails {
    /** The annual premium details. */
    annual: Premium;
    /** The monthly premium details. */
    monthly: MonthlyPremium;
}

/** The cost of premium for the selected risk/policy details. */
export interface Premium {
    /** The total amount including GST component. */
    total: number;
    /** The GST component. */
    gst: number;
    /** The basic component (Basic = Total - Gst - GovernmentCharges). */
    basic: number;
    /** The government charges (stamp duty) component. */
    governmentCharges: number;
}

/** The cost of premium for the selected risk/policy details. */
export interface MonthlyPremium extends Premium {
    /** The monthly installment amount. */
    installment: number;
}

/** Object to create and update a cover. */
export interface CoverRequest {
    /** The cover type. */
    coverType: string;
    /** The excess amount for the cover. */
    excess: number;
    /** The sum insured details. */
    sumInsured?: number | undefined;
    /** Indicates if the member has selected a cover option for their 'quote'. */
    hasSelectedCover?: boolean | undefined;
}

/** Object to update the policy details of a quote. */
export interface LetsClarifyMoreDetailsRequest {
    /** The start date of the policy. */
    startDate: Date;
    /** The motorcycles registration number. */
    registrationNumber?: string | undefined;
}

/** Object to update a contacts details. */
export interface UpdateContactDetailsRequest {
    /** The details of the contact(s). */
    contacts?: Contact[] | undefined;
}

/** The contacts details. */
export interface Contact {
    /** The contacts title. */
    title?: ContactTitle | undefined;
    /** The contacts gender. */
    gender?: ContactGender | undefined;
    /** The contacts first name. */
    firstName?: string | undefined;
    /** The contacts middle name. */
    middleName?: string | undefined;
    /** The contacts surname. */
    surname?: string | undefined;
    /** The contacts phone number (could be landline or mobile). */
    contactNumber?: string | undefined;
    /** The contacts email. */
    email?: string | undefined;
    /** The contacts mailing address moniker. */
    mailingAddress: string;
}

/** Contains the reference data that is required in the payment page. */
export interface PaymentReferenceData {
    /** Publishable Westpac API Key. */
    westpacPublishableApiKey: string;
    /** The payment options. */
    paymentOptions: PaymentOptions;
}

/** The payment account details for the bank account. */
export interface BankAccountDetailsRequest {
    /** The accounts BSB number. */
    bsb: string;
    /** The account number. */
    accountNumber: string;
    /** The account name. */
    accountName: string;
}

/** The payment account details for the credit card. */
export interface CreditCardDetailsRequest {
    /** The Westpac single use token. */
    token: string;
}

/** Contains the payment details to issue a policy. */
export interface PaymentRequestBase {
    /** The payment frequency. */
    frequency: PaymentFrequency;
}

/** Contains the payment details to issue a policy. */
export interface BankAccountPaymentRequest extends PaymentRequestBase {
    /** The payment account details. */
    accountDetails: BankAccountDetailsRequest;
}

/** Contains the payment details to issue a policy. */
export interface CreditCardPaymentRequest extends PaymentRequestBase {
    /** The payment account details. */
    accountDetails: CreditCardDetailsRequest;
}

/** Contains the payment response details with policy issued. */
export interface PaymentResponse {
    /** The policy number. */
    policyNumber: string;
}

/** The payment options. */
export interface PaymentOptions {
    /** The payment frequency. */
    frequency: PaymentFrequency;
    /** The payment method. */
    method: PaymentMethod;
}

export enum PaymentFrequency {
    Monthly = "Monthly",
    Annual = "Annual",
}

export enum PaymentMethod {
    Card = "Card",
    Bank_account = "Bank account",
}

/** Information about a question. */
export interface QuestionInformation {
    /** Whether the question is required or not (mandatory or not). */
    isRequired: boolean;
}

/** Information about questions pertaining to Tell Us More About You. */
export interface TellUsMoreAboutYouQuestionsResponse {
    /** Information about the Title question. */
    title: QuestionInformation;
    /** Information about the Gender question. */
    gender: QuestionInformation;
}

/** Information about the score of a formotiv model run */
export interface FormotivModelScoreResponse {
    /** The formotiv model run score */
    score: number;
}

export enum RiderExperience {
    _01 = "0-1",
    _12 = "1-2",
    _23 = "2-3",
    _3_ = "3+",
}

export enum ContactTitle {
    Mr = "Mr",
    Mrs = "Mrs",
    Ms = "Ms",
    Miss = "Miss",
    Doctor = "Doctor",
    MX = "MX",
}

export enum ContactGender {
    Male = "Male",
    Female = "Female",
}

export class ApiResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}